const merge = require('deepmerge');
const Ajv = require('ajv').default;

let { standardSchemas } = require('./schemas');

const ajv = new Ajv();
const ANALYTICS_JLDATA_UPDATED = 'JlDataUpdateComplete';

const analyticsReady = () => {
  return (
    window && window.Bootstrapper && window.Bootstrapper.dataStateChangeReady
  );
};

const addCustomSchema = (schema) => {
  standardSchemas = { ...standardSchemas, ...schema };
  return;
};

const validateEventPayload = (eventName, data) => {
  if (!standardSchemas[eventName] || !standardSchemas[eventName].payload)
    return true;

  const validatePayload = ajv.compile(standardSchemas[eventName].payload);
  const result = validatePayload(data);
  return result;
};

const validateEventDataLayer = (eventName) => {
  if (!standardSchemas[eventName] || !standardSchemas[eventName].dataLayer)
    return true;

  const validateDataLayer = ajv.compile(standardSchemas[eventName].dataLayer);
  return validateDataLayer(window.jlData);
};

const dispatchImmediateAnalyticsEvent = (eventName, data = {}) =>
  new Promise((resolve, reject) => {
    if (!validateEventPayload(eventName, data))
      return reject('Invalid data for this event type');
    const event = new CustomEvent('dataStateChange', {
      detail: {
        action: eventName,
        ...data,
      },
    });

    document.body.dispatchEvent(event);

    console.log(`dispatched immediate "${eventName}": %O`, data);

    resolve(event);
  });

const dispatchAnalyticsEvent = (
  eventName,
  data = {},
  { timeout = 3000, predecessorEventName = ANALYTICS_JLDATA_UPDATED } = {}
) => {
  const event = new CustomEvent('dataStateChange', {
    detail: {
      action: eventName,
      ...data,
    },
  });

  console.log(`waiting to dispatch "${eventName}": %O`, data);

  const deferredDispatchPromise = new Promise((resolve, reject) => {
    let wait;

    if (!validateEventPayload(eventName, data))
      return reject('Invalid data for this event type');

    const listener = () => {
      if (!validateEventDataLayer(eventName)) {
        document.body.removeEventListener(predecessorEventName, listener);
        clearTimeout(wait);
        return reject('Invalid DataLayer for this event type');
      }
      document.body.dispatchEvent(event);
      console.log(`dispatched "${eventName}": %O`, data);
      document.body.removeEventListener(predecessorEventName, listener);
      clearTimeout(wait);
      resolve(event);
    };

    console.log(`adding listener for "${predecessorEventName}" event`);
    document.body.addEventListener(predecessorEventName, listener, {
      once: true,
    });

    wait = setTimeout(() => {
      console.log(`timed out waiting to dispatch "${eventName}": %O`, data);
      document.body.removeEventListener(predecessorEventName, listener);

      reject();
    }, timeout);
  });

  return deferredDispatchPromise.catch(() => {
    console.log(
      `WARNING: expected "${eventName}" to trigger but it did not.`,
      event
    );
  });
};

const setJLData = (payload) => {
  if (!payload || typeof payload !== 'object') return;

  window.jlData = merge(window.jlData || {}, payload, {});
};

const getStandardSchemas = () => standardSchemas;

module.exports = {
  analyticsReady,
  dispatchImmediateAnalyticsEvent,
  dispatchAnalyticsEvent,
  setJLData,
  getStandardSchemas,
  validateEventDataLayer,
  validateEventPayload,
  addCustomSchema,
  ANALYTICS_JLDATA_UPDATED,
};
